import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';

export const intermediaryGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const router = inject(Router);
  const user = globalService.loggedUserClass;

  if (!authService.isLoggedin(user)) {
    router.navigate(['/login']);
    return false;
  }

  if (user?.Admin || user?.IntermediaryArea) {
    return true;
  }

  router.navigate(['/home']);
  return false;
};
